import { createNamespacedHelpers } from "vuex-composition-helpers";
const {
  useActions,
  useGetters,
  useMutations,
  useState
} = createNamespacedHelpers("AccountStore");
export const useAccountStoreActions = useActions;
export const useAccountStoreGetters = useGetters;
export const useAccountStoreMutations = useMutations;
export const useAccountStoreState = useState;